import { Decorative } from "@faire/design-tokens";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import styled from "styled-components";
export var DesertBackground = styled(Column).withConfig({
    componentId: "sc-dc708424-0"
})([
    "background-color:",
    ";"
], Decorative.shade.yellow);
export var FieldBackground = styled(Column).withConfig({
    componentId: "sc-dc708424-1"
})([
    "background-color:",
    ";"
], Decorative.icon.green);
export var VanillaBackground = styled(Column).withConfig({
    componentId: "sc-dc708424-2"
})([
    "background:",
    ";"
], Decorative.tint.neutral);
export var MOBILE_PADDING = "48px";
export var TABLET_PADDING = "120px";
export var ContentContainer = styled(Column).withConfig({
    componentId: "sc-dc708424-3"
})([
    "width:100%;max-width:1440px;margin:0 auto;padding:0 ",
    ";",
    "{padding:0 ",
    ";}",
    "{padding:",
    ";}"
], MOBILE_PADDING, responsiveMediaQueries.tablet, TABLET_PADDING, responsiveMediaQueries.desktopAndAbove, getSpacing(0, 104));
